<style src="./ControlButton.scss" lang="scss"></style>

<template lang="pug">
  button.control-button(
    :class="classList"
    type='button'
  )
    span.control-button__icon
      Icon(
        :name='icon'
      )
    span.control-button__text(
      v-if='text'
    ) {{ text }}
</template>
<script>
import Icon from "@/components/Icon/Icon";

export default {
  props: ["icon", "type", "size", "text"],
  components: { Icon },
  computed: {
    classList() {
      return {
        [`is-${this.type}`]: this.type,
        [`is-${this.size}`]: this.size,
        "has-text": this.text
      };
    }
  }
};
</script>
